/**
 * Aba Notificações (C3) — fiel ao mockup (.switch-row / .switch).
 * Consome o backend B1: GET/PUT /api/me/notificacoes-preferencias.
 */
import React, { useCallback, useEffect, useState } from "react";

import { useAuth } from "../../../context/AuthContext";
import { useToast } from "../../../context/ToastContext";
import {
  getPreferenciasNotificacao,
  salvarPreferenciasNotificacao,
} from "../../../services/configuracoes";

// M-TRA-11 (decisao do dono, 2026-08-11): esta aba oferecia 5 chaves e
// NENHUMA era lida por lugar nenhum — o usuario desligava "menções e
// comentários" e continuava recebendo, desligava o resumo diário que
// nunca existiu. Preferencia que nao muda nada e pior que preferencia
// ausente: ensina a pessoa a nao confiar na tela.
//
// Sobrou a unica com leitor de verdade (o alerta de gargalo, construido
// junto — M-PRO-6). As outras 4 voltam quando alguem as ler.
const ITENS = [
  { key: "alertas_producao_toc", t: "Alertas de produção (TOC)", d: "Mudança de gargalo e buffers críticos" },
];

const DEFAULTS = {
  alertas_producao_toc: true,
};

export default function NotificacoesTab() {
  const { request } = useAuth();
  const toast = useToast();
  const [prefs, setPrefs] = useState(DEFAULTS);
  const [carregado, setCarregado] = useState(false);

  const carregar = useCallback(async () => {
    try {
      const data = await getPreferenciasNotificacao(request);
      if (data && typeof data === "object") setPrefs((p) => ({ ...p, ...data }));
    } catch (err) {
      toast.error(err?.message || "Falha ao carregar preferências.");
    } finally {
      setCarregado(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  async function alternar(key) {
    const novo = !prefs[key];
    setPrefs((p) => ({ ...p, [key]: novo })); // otimista
    try {
      await salvarPreferenciasNotificacao(request, { [key]: novo });
    } catch (err) {
      setPrefs((p) => ({ ...p, [key]: !novo })); // reverte
      toast.error(err?.message || "Não foi possível salvar.");
    }
  }

  return (
    <section className="set-section">
      <div className="set-section__head">
        <h2 className="set-section__title">Notificações</h2>
        <p className="set-section__desc">Escolha o que e como você quer ser avisado.</p>
      </div>
      <div
        className="set-section__body"
        style={{ opacity: carregado ? 1 : 0.6, pointerEvents: carregado ? "auto" : "none" }}
      >
        {ITENS.map((it) => (
          <div className="switch-row" key={it.key}>
            <div className="sr-txt">
              <div className="t">{it.t}</div>
              <div className="d">{it.d}</div>
            </div>
            <div
              className={`switch ${prefs[it.key] ? "is-on" : ""}`}
              role="switch"
              aria-checked={Boolean(prefs[it.key])}
              aria-label={it.t}
              tabIndex={carregado ? 0 : -1}
              onClick={() => alternar(it.key)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  alternar(it.key);
                }
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
